import script from "./LoginDorape.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginDorape.vue?vue&type=script&setup=true&lang=ts"

import "./LoginDorape.vue?vue&type=style&index=0&id=65d5f8c6&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d5f8c6"]])

export default __exports__